var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 62,
    height: 62,
    rx: 31,
    fill: "#F5F5F5",
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 31C34.2091 31 36 29.2091 36 27C36 24.7909 34.2091 23 32 23C29.7909 23 28 24.7909 28 27C28 29.2091 29.7909 31 32 31ZM32 32C34.7614 32 37 29.7614 37 27C37 24.2386 34.7614 22 32 22C29.2386 22 27 24.2386 27 27C27 29.7614 29.2386 32 32 32Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 35.5C26.5147 35.5 24.5 37.5147 24.5 40V41C24.5 41.2761 24.2761 41.5 24 41.5C23.7239 41.5 23.5 41.2761 23.5 41V40C23.5 36.9624 25.9624 34.5 29 34.5H35C38.0376 34.5 40.5 36.9624 40.5 40V41C40.5 41.2761 40.2761 41.5 40 41.5C39.7239 41.5 39.5 41.2761 39.5 41V40C39.5 37.5147 37.4853 35.5 35 35.5H29Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserRounded);
export default __webpack_public_path__ + "static/media/user-rounded.7b9416c3754d65f3b5c57c3a17058ea3.svg";
export { ForwardRef as ReactComponent };